import { useState, useEffect } from "react";

const useRecaptcha = () => {
  // console.log("RECAPTCHA_SITE_KEY_LOADED-hook:", process.env.RECAPTCHA_SITE_KEY);

  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  const siteKey = process.env.RECAPTCHA_SITE_KEY;

  useEffect(() => {
    if (!document.querySelector('script[src*="recaptcha/api.js"]')) {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      script.onload = () => setIsScriptLoaded(true);
      document.body.appendChild(script);

      return () => {
        const existingScript = document.querySelector(
          'script[src*="recaptcha/api.js"]'
        );
        if (existingScript) {
          document.body.removeChild(existingScript);
        }
      };
    } else {
      setIsScriptLoaded(true);
    }
  }, [siteKey]);

  const generateToken = async (action = "submit") => {
    if (isScriptLoaded && window.grecaptcha) {
      try {
        return await new Promise((resolve, reject) => {
          window.grecaptcha.ready(() => {
            window.grecaptcha
              .execute(siteKey, { action })
              .then(resolve)
              .catch(reject);
          });
        });
      } catch (error) {
        console.error("Error generating token:", error);
        return null;
      }
    } else {
      console.error("reCAPTCHA script not ready");
      return null;
    }
  };

  return { generateToken };
};

export default useRecaptcha;
